module.exports = require("vue-amap");